<div class="-product-skeleton-wrapper">
  <div class="-product-skeleton-content">
    <div class="-product-skeleton-breadcrumbs">
      @for (crumbWidth of ['48px', '34px', '26px', '92px']; track $index) {
      <wp-skeleton height="12px" [width]="crumbWidth" [loading]="true"></wp-skeleton>
      }
    </div>

    <div class="-product-skeleton-anchor">
      <span class="-product-skeleton-anchor-icon"></span>
    </div>

    <wp-skeleton height="42px" [width]="'24%'" [loading]="true"></wp-skeleton>
    <wp-skeleton height="14px" [width]="'84%'" [loading]="true"></wp-skeleton>
    <wp-skeleton height="14px" [width]="'96%'" [loading]="true"></wp-skeleton>
    <wp-skeleton height="14px" [width]="'100%'" [loading]="true"></wp-skeleton>
    <wp-skeleton height="14px" [width]="'94%'" [loading]="true"></wp-skeleton>

    <wp-skeleton height="36px" [width]="'28%'" [loading]="true"></wp-skeleton>
    <wp-skeleton height="14px" [width]="'82%'" [loading]="true"></wp-skeleton>
    <wp-skeleton height="14px" [width]="'96%'" [loading]="true"></wp-skeleton>

    @for (section of [1,2]; track section) {
    <div class="-product-section-skeleton">
      <wp-skeleton height="30px" [width]="'26%'" [loading]="true"></wp-skeleton>
      <wp-skeleton height="14px" [width]="'90%'" [loading]="true"></wp-skeleton>
      <wp-skeleton height="14px" [width]="'97%'" [loading]="true"></wp-skeleton>
      <wp-skeleton height="14px" [width]="'78%'" [loading]="true"></wp-skeleton>
    </div>
    }
  </div>
</div>
